import React, { useState } from 'react';
import { Navigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { API_URL } from '../config/API_URLS.tsx';
import { authenticatedFetch } from "../auth/RequestSigner.tsx";
import SuccessModal from "./SuccessModal.tsx";
import ErrorModal from "./ErrorModal.tsx";

function RegistrationFormEmployers() {
  const [name, setName] = useState("");
  const [last_name, setLastName] = useState("");
  const [document, setDocument] = useState("");
  const [documentSender, setDocumentSender] = useState("");
  const [loading, setLoading] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [showError, setShowError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);  
  const rollSender = parseInt(queryParams.get('rollSender')) || '';

  const handleSubmit = async (event) => {
      event.preventDefault();
      setLoading(true);

      try {
          let apiURL = "";

          if (rollSender === 1) {
            apiURL =  `${API_URL}/v1/admins-registration`;
          } else if (rollSender === 3) {
            apiURL = `${API_URL}/v1/vigilantes-registration`;
          }

          const response = await authenticatedFetch(`${apiURL}`, {
            method: 'post',
            body: JSON.stringify({ name, last_name, document, "registry_date": "string"}),
            headers: {
              'Content-Type': 'application/json'
            }                
          });

          if (!response.ok) {
            throw new Error('Error al registrar el empleado. Por favor, intente nuevamente.');            
          }
          
          setLoading(false);
          setShowSuccess(true);
          setTimeout(() => {
            setDocumentSender(document);
          }, 2000);
      } catch (error) {
          console.error('Error:', error);
          setErrorMessage(error.message || 'Error al crear el empleado');
          setShowError(true);
          setLoading(false);
      }
  };

  const handleCloseErrorModal = () => {
    setShowError(false);
  };

  const handleCloseSuccessModal = () => {
    setShowSuccess(false);
    setDocumentSender(document);
  };

  if (documentSender) {
    const route = `/set-password?document=${documentSender}&roll=${rollSender}`;
    return <Navigate to={route} />;
  }

  return (
    <div className="flex-1 flex items-center justify-center bg-gradient-to-b px-4 py-8" data-testid="registration-form-employers-container">
      <div className="bg-white rounded-xl shadow-lg p-8 max-w-md w-full border border-gray-200" data-testid="registration-form-employers-wrapper">
        <div className="mb-8 text-center">
          <h2 className="text-2xl font-bold text-gray-800 mb-2" data-testid="registration-form-employers-title">
            Registro de Empleado
          </h2>
          <p className="text-gray-600">
            Completa el formulario para registrar un nuevo empleado
          </p>
        </div>
        
        <form onSubmit={handleSubmit} data-testid="registration-form-employers-form">
          <div className="space-y-6">
            <div className="mb-4" data-testid="registration-form-employers-name-field">
              <label htmlFor="name" className="block text-gray-700 font-medium mb-2" data-testid="registration-form-employers-name-label">Nombre</label>
              <input
                type="text"
                id="name"
                name="name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-transparent transition-all"
                required
                placeholder="Ingresa el nombre"
                data-testid="registration-form-employers-name-input"
              />
            </div>
            
            <div className="mb-4" data-testid="registration-form-employers-lastname-field">
              <label htmlFor="last_name" className="block text-gray-700 font-medium mb-2" data-testid="registration-form-employers-lastname-label">Apellidos</label>
              <input
                type="text"
                id="last_name"
                name="last_name"
                value={last_name}
                onChange={(e) => setLastName(e.target.value)}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-transparent transition-all"
                required
                placeholder="Ingresa los apellidos"
                data-testid="registration-form-employers-lastname-input"
              />
            </div>
            
            <div className="mb-6" data-testid="registration-form-employers-document-field">
              <label htmlFor="document" className="block text-gray-700 font-medium mb-2" data-testid="registration-form-employers-document-label">Documento</label>
              <input
                type="text"
                id="document"
                name="document"
                value={document}
                onChange={(e) => setDocument(e.target.value)}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-transparent transition-all"
                required
                placeholder="Ingresa el número de documento"
                data-testid="registration-form-employers-document-input"
              />
            </div>
            
            <button
              type="submit"
              disabled={loading}
              className="w-full px-4 py-3 text-gray-900 text-base font-semibold rounded-lg shadow-md flex items-center justify-center relative overflow-hidden group"
              data-testid="registration-form-employers-submit"
            >
              <div className="absolute inset-0 bg-gradient-to-t from-amber-300 to-amber-700 transition-transform duration-700 ease-in-out"></div>
              <div className="absolute inset-0 bg-gradient-to-b from-amber-300 to-amber-700 opacity-0 group-hover:opacity-100 transition-opacity duration-700 ease-in-out"></div>
              <span className="z-10">
                {loading ? (
                  <div className="flex items-center">
                    <div className="animate-spin rounded-full h-5 w-5 border-t-2 border-b-2 border-white mr-2"></div>
                    <span>Registrando...</span>
                  </div>
                ) : (
                  "Registrar Empleado"
                )}
              </span>
            </button>
          </div>
        </form>
      </div>
      
      <SuccessModal
        isOpen={showSuccess}
        onClose={handleCloseSuccessModal}
        message="Empleado registrado con éxito. A continuación, establece una contraseña para el usuario."
      />
      
      <ErrorModal
        isOpen={showError}
        onClose={handleCloseErrorModal}
        message={errorMessage}
      />
    </div>
  );
}

export { RegistrationFormEmployers };
